import { CNDDistrictListPayloadSchema } from 'src/models/cnd-district.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('/cndDistricts', { limit: 0 }, CNDDistrictListPayloadSchema);
  },
};

export default services;
